"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var App_1 = require("../../App");
var paginatorList_1 = require("./paginatorList");
var editablelist_1 = require("./editablelist");
var matrixDialog_1 = require("./evaluation/matrixDialog");
var urls_1 = require("../../urls");
var contexts_1 = require("../../interfaces/contexts");
var utils_1 = require("../../utils");
var risks_1 = require("../../interfaces/risks");
var iterUtils_1 = require("../lib/iterUtils");
var controls_1 = require("../../interfaces/controls");
var columns_1 = require("./columns");
var api_1 = require("../../api");
var causalityDialog_1 = require("../causalities/causalityDialog");
var referenceDialog_1 = require("../references/referenceDialog");
var RiskTable = (function (_super) {
    __extends(RiskTable, _super);
    function RiskTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.riskClickHandler = function (event, risk_id) {
            (0, utils_1.preventDefault)(event);
            var context = App_1.store.context.get();
            if (context instanceof contexts_1.ProjectContext) {
                var project_id = context.project;
                var params = window.location.search;
                var url = (0, urls_1.resolve)(urls_1.Urls.risk_detail, project_id, risk_id) + params;
                if (event.ctrlKey) {
                    window.open(url, '_blank');
                }
                else {
                    window.location.href = url;
                }
            }
        };
        _this.controlLinkClickHandler = function (control_id) {
            var location = window.location.search;
            var params = new URLSearchParams(location);
            params.set("control_id", control_id.toString());
            window.history.pushState(null, null, window.location.pathname + "?" + params.toString());
            _this.openControlDialog(control_id);
        };
        _this.openControlDialog = function (control_id) {
            var context = App_1.store.context.get();
            if (context instanceof contexts_1.ProjectContext) {
                api_1.api.projects.id(context.project).controls.id(control_id).get().then(function (control) {
                    App_1.store.controlDialog.openDialog(control);
                });
            }
            else {
                throw new Error("ControlDialog cannot be opened outside of Project context");
            }
        };
        _this.refetchTable = function (event) {
            var params = window.location.search;
            if (event) {
                (0, utils_1.preventDefault)(event);
                var url = new URL(event.currentTarget.href);
                var search = new URLSearchParams(url.search);
                params = "?" + search.toString();
            }
            window.history.pushState(null, null, window.location.pathname + params);
            App_1.store.risklist.fetchData(params);
            App_1.store.risklist.filter.fetchData();
        };
        return _this;
    }
    RiskTable.prototype.closeAttachedControlsConfirmation = function (data) {
        var _this = this;
        return selectOptionConfirmation({
            header: App_1.store.closeAttachedControlsDialog.title,
            message: App_1.store.closeAttachedControlsDialog.buildMessage(),
            choices: App_1.store.closeAttachedControlsDialog.getChoices(data.status.toString()),
            onSave: function (status) {
                if ((0, iterUtils_1.contains)(controls_1.ControlStatusChoices.toStringList(), status)) {
                    return App_1.store.closeAttachedControlsDialog
                        .setStatusOnControls
                        .bind(App_1.store.closeAttachedControlsDialog)(status)
                        .then(function () { return App_1.store.risklist.updateRows(data).then(function (response) {
                        notification(response.message);
                        _this.refetchTable();
                    }); });
                }
                else {
                    data["ignore_control_warning"] = true;
                    return App_1.store.risklist.updateRows(data).then(function (response) {
                        notification(response.message);
                        _this.refetchTable();
                    });
                }
            },
            onClose: App_1.store.closeAttachedControlsDialog.closeDialog
                .bind(App_1.store.closeAttachedControlsDialog),
        });
    };
    RiskTable.prototype.performBulkUpdate = function (selected, values) {
        values["risks"] = selected;
        return App_1.store.risklist.updateRows(values);
    };
    RiskTable.prototype.performRowUpdate = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (typeof data.id === "number" &&
                    data.status &&
                    (0, iterUtils_1.contains)(risks_1.RiskStatusChoices.COMPLETE.map(function (c) { return c.toString(); }), data.status)) {
                    return [2, App_1.store.closeAttachedControlsDialog.fetchAttachedControls(data.id)
                            .then(function () {
                            if (App_1.store.closeAttachedControlsDialog.controls.length > 0) {
                                return _this.closeAttachedControlsConfirmation(data);
                            }
                            else {
                                return App_1.store.risklist.updateRows(data).then(function (response) {
                                    notification(response.message);
                                });
                            }
                        })];
                }
                return [2, App_1.store.risklist.updateRows(data).then(function (response) {
                        notification(response.message);
                    })];
            });
        });
    };
    RiskTable.prototype.detachCausality = function (c, risk_id) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, App_1.store.risklist.checkDetachCausality(c, risk_id).then(function (page) {
                        return App_1.store.risklist.removeCausality(c, risk_id).then(function () {
                            _this.refetchTable();
                            return Promise.resolve(true);
                        });
                    }, function (error) {
                        var reason = JSON.parse(error.responseText);
                        if (reason.confirm) {
                            return optionDialog(reason.confirm, [{
                                    text: gettext("Retain confidentiality"),
                                    "class": "btn btn-primary",
                                    click: function () { return App_1.store.risklist.removeCausality(c, risk_id, true).then(function () {
                                        _this.refetchTable();
                                        return Promise.resolve(true);
                                    }); }
                                }, {
                                    text: gettext("Make public"),
                                    "class": "btn btn-secondary",
                                    click: function () { return App_1.store.risklist.removeCausality(c, risk_id, false).then(function () {
                                        _this.refetchTable();
                                        return Promise.resolve(true);
                                    }); }
                                }], null, null, 500);
                        }
                        else {
                            return Promise.resolve(true);
                        }
                    })];
            });
        });
    };
    RiskTable.prototype.detachControl = function (control, risk_id) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, App_1.store.risklist.checkDetachControl(control, risk_id).then(function (page) {
                        return App_1.store.risklist.removeControl(control, risk_id).then(function () {
                            _this.refetchTable();
                            return Promise.resolve(true);
                        });
                    }, function (error) {
                        var reason = JSON.parse(error.responseText);
                        if (reason.confirm) {
                            return optionDialog(reason.confirm, [{
                                    text: gettext("Retain confidentiality"),
                                    "class": "btn btn-primary",
                                    click: function () { return App_1.store.risklist.removeControl(control, risk_id, true); }
                                }, {
                                    text: gettext("Make public"),
                                    "class": "btn btn-secondary",
                                    click: function () { return App_1.store.risklist.removeControl(control, risk_id, false); }
                                }], null, null, 500);
                        }
                        else {
                            return Promise.resolve(false);
                        }
                    })];
            });
        });
    };
    RiskTable.prototype.getReferenceDialogFormProps = function () {
        var formProps = App_1.store.referenceDialog.getFormProps();
        var self = this;
        return __assign(__assign({}, formProps), { onSave: function () { return formProps.onSave().then(function () { return self.refetchTable(); }); } });
    };
    RiskTable.prototype.render = function () {
        var relationsProps = {};
        relationsProps[columns_1.RiskColumnIds.CAUSE] = {
            fetchSearchResults: App_1.store.risklist.fetchAttachableCausalitySuggestions,
            fetchRowItems: App_1.store.risklist.fetchRowCausalities,
            attach: App_1.store.risklist.attachCausality,
            detach: this.detachCausality.bind(this),
            edit: App_1.store.causeDialog.openDialog.bind(App_1.store.causeDialog),
        };
        relationsProps[columns_1.RiskColumnIds.EFFECT] = {
            fetchSearchResults: App_1.store.risklist.fetchAttachableCausalitySuggestions,
            fetchRowItems: App_1.store.risklist.fetchRowCausalities,
            attach: App_1.store.risklist.attachCausality,
            detach: this.detachCausality.bind(this),
            edit: App_1.store.effectDialog.openDialog.bind(App_1.store.effectDialog),
        };
        relationsProps[columns_1.RiskColumnIds.CONTROLS] = {
            fetchSearchResults: App_1.store.risklist.fetchAttachableControlSuggestions,
            fetchRowItems: App_1.store.risklist.fetchRowControls,
            attach: App_1.store.risklist.attachControl,
            detach: this.detachControl.bind(this),
            onRelationLinkClick: this.controlLinkClickHandler.bind(this),
        };
        return (React.createElement("div", { className: "RiskTable" },
            React.createElement(editablelist_1.EditableList, { columns: App_1.store.risklist.data.columns, headers: App_1.store.risklist.data.headers, rows: App_1.store.risklist.data.rows, rowClickHandler: this.riskClickHandler, performRowUpdate: this.performRowUpdate.bind(this), refetchTable: this.refetchTable, relationProps: relationsProps, allowBulkEditing: true, performBulkUpdate: this.performBulkUpdate, bulkEditFields: App_1.store.risklist.data.bulk_edit_fields, headerSortClickHandler: this.refetchTable, bulkMenuState: App_1.store.risklist.bulkMenu.data, updateBulkMenuState: App_1.store.risklist.bulkMenu.getFetchDataMethod() }),
            React.createElement("div", { className: "RiskTable__Footer" },
                React.createElement(paginatorList_1.default, { paginator: App_1.store.risklist.data.paginator, click: this.refetchTable })),
            React.createElement(matrixDialog_1.default, { show: App_1.store.risklist.evaluation.isOpen, data: App_1.store.risklist.evaluation.matrixData }),
            React.createElement("div", { className: "RiskTable__CauseDialog" },
                React.createElement(causalityDialog_1.CausalityDialog, { isCause: App_1.store.causeDialog.isCause, isOpen: App_1.store.causeDialog.isOpen, causality: App_1.store.causeDialog.causality, causeSearchResults: App_1.store.causeDialog.causeSearchResults, effectSearchResults: App_1.store.causeDialog.effectSearchResults, affectedRisks: App_1.store.causeDialog.affectedRisks, affectedControls: App_1.store.causeDialog.affectedControls, isLoadingRisks: App_1.store.causeDialog.isLoadingRisks, isLoadingControls: App_1.store.causeDialog.isLoadingControls, isSearchingCausalities: false, saveCausality: App_1.store.causeDialog.saveCausality, search: App_1.store.causeDialog.search, attachCausality: App_1.store.causeDialog.attachCausality, closeDialog: App_1.store.causeDialog.closeDialog, openDialog: App_1.store.causeDialog.openDialog, afterSaveCallback: this.refetchTable.bind(this), comments: App_1.store.causeDialog.comments, udfTypes: App_1.store.causeDialog.udfTypes, udfSectionHeader: App_1.store.causeDialog.udfSectionHeader, refreshAfterClose: App_1.store.causeDialog.refreshAfterClose })),
            React.createElement("div", { className: "RiskTable__EffectDialog" },
                React.createElement(causalityDialog_1.CausalityDialog, { isCause: App_1.store.effectDialog.isCause, isOpen: App_1.store.effectDialog.isOpen, causality: App_1.store.effectDialog.causality, causeSearchResults: App_1.store.effectDialog.causeSearchResults, effectSearchResults: App_1.store.effectDialog.effectSearchResults, affectedRisks: App_1.store.effectDialog.affectedRisks, affectedControls: App_1.store.effectDialog.affectedControls, isLoadingRisks: App_1.store.effectDialog.isLoadingRisks, isLoadingControls: App_1.store.effectDialog.isLoadingControls, isSearchingCausalities: false, saveCausality: App_1.store.effectDialog.saveCausality, search: App_1.store.effectDialog.search, attachCausality: App_1.store.effectDialog.attachCausality, closeDialog: App_1.store.effectDialog.closeDialog, openDialog: App_1.store.effectDialog.openDialog, afterSaveCallback: this.refetchTable.bind(this), comments: App_1.store.effectDialog.comments, udfTypes: App_1.store.effectDialog.udfTypes, udfSectionHeader: App_1.store.effectDialog.udfSectionHeader, refreshAfterClose: App_1.store.effectDialog.refreshAfterClose })),
            React.createElement(referenceDialog_1.ReferenceDialog, { reference: App_1.store.referenceDialog.reference, isOpen: App_1.store.referenceDialog.isOpen, isReady: App_1.store.referenceDialog.isReady, onDialogClose: App_1.store.referenceDialog.closeDialog.bind(App_1.store.referenceDialog), formProps: this.getReferenceDialogFormProps.bind(this)() })));
    };
    RiskTable = __decorate([
        mobx_react_1.observer
    ], RiskTable);
    return RiskTable;
}(React.Component));
exports.default = RiskTable;
